import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { PageLayoutComponent } from './core/components/page-layout/page-layout.component';
import { L10nIntlModule } from 'angular-l10n';
import { HttpSupplierDbService } from './core/services/http/httpSupplierDB.service';
import { ActivatedRoute } from '@angular/router';
import { AppConstants } from './app.constants';
import { Subscription } from 'rxjs';
import { SupplierContactFormModel } from './core/models/supplierDB/supplierContactForm.model';
@Component({
  selector: 'supplierDB-registration-root',
  standalone: true,
  imports: [PageLayoutComponent, L10nIntlModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  private _queryParamsSubscription!: Subscription;

  constructor(
    private primengConfig: PrimeNGConfig,
    private _supplierService: HttpSupplierDbService,
    private _route: ActivatedRoute
  ) {}

  title = 'Supplier Registration';

  ngOnInit(): void {
    this.primengConfig.ripple = true;

    this._queryParamsSubscription = this._route.queryParams.subscribe(params => {
      if (params["token"]) {
        localStorage.setItem(AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_ACCESS_TOKEN, params["token"]);
        this._loadDataFromToken(params["token"]);
      } else {
        var token = localStorage.getItem(AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_ACCESS_TOKEN);
        if (!token) {
          localStorage.removeItem(AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_ACCESS_TOKEN);
          window.location.href = AppConstants.LOGIN_PAGE_URL;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this._queryParamsSubscription.unsubscribe();
  }

  private _loadDataFromToken(token: string): void {
    this._supplierService.loadDataByToken(token).subscribe((result) => {
      if (result) {
        localStorage.setItem(
          AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_CONTACT,
          JSON.stringify(new SupplierContactFormModel(result))
        );
        localStorage.removeItem(AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_LOGO);
        localStorage.removeItem(AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_SELECTION);
      } else {
        window.location.href = AppConstants.LOGIN_PAGE_URL;
      }
    })
  }
}
